<!-- 
Dialog for performing a task for a levy collection provider that requires an explanation to be entered.
-->
<template>
  <dialog-base
    ref="base"
    v-model="show"
    :levy-collection-id="levyCollectionId"
    :provider-id="providerId"
    :task="task"
    user-guide-topic="levy-collection-providers"
    user-guide-section="running-a-levy-collection-provider-task"
    @run="validateAndRun"
    @hide="hide"
  >
    <v-textarea
      v-model="explanation"
      :rules="[rules.required]"
      label="Explanation*" height="30" class="mt-5" autofocus
    />
  </dialog-base>
</template>

<script>
import DialogBase from "./DialogBase.vue";
import mixins from "./mixins";

export default {
  components: { DialogBase },
  mixins: [mixins],
  methods: {
    validateAndRun() {
      if (this.$refs.base.validate()) {
        this.run();
      }
    }
  }
};
</script>
